module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/keyboard-b139f326eb45f8ea63d805251f7a85d8.svg";